import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import VerticalLabretLipPiercingImage from '../../Assets/Piercing Services/vertical labret piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function VerticalLabretLipPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Vertical Labret Lip Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Vertical Labret Lip Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Vertical Labret Lip Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={VerticalLabretLipPiercingImage} alt="Vertical Labret Lip Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Vertical Labret Lip Piercing</h3>

          <p>
            Stand out with a bold and distinctive look through our professional vertical labret lip piercing services in the UAE, available at an affordable price of 250 AED. Vertical labret lip piercing is a unique and stylish facial piercing that passes vertically through the lower lip, with both ends of the jewelry visible, creating a striking and modern appearance. Unlike traditional lip piercings, this style does not go inside the mouth, making it a popular choice for those seeking both comfort and visual impact. Perfect for individuals who want something different and eye-catching, the vertical labret piercing adds a creative flair to your overall style while enhancing the natural shape of your lips.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each vertical labret piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. This type of piercing requires expertise due to its vertical placement, and our experienced specialists are trained to execute the procedure accurately while minimizing discomfort.
          </p>

          <p>
            Vertical labret lip piercing is ideal for individuals who want to express their personality with a bold yet refined style. Its unique positioning creates a strong visual impact while maintaining a clean and balanced look. This piercing can be worn with curved barbells featuring decorative ends, allowing you to customize your appearance with different designs and styles. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options and placement to suit your facial structure and desired look.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that facial piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your vertical labret piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Since this piercing does not pass through the inside of the mouth, aftercare is generally simpler compared to traditional lip piercings, making it a convenient option for many clients.
          </p>

          <p>
            Our vertical labret lip piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted vertical labret lip piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and unique look effortlessly. Book your vertical labret piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Vertical Labret Lip Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default VerticalLabretLipPiercing;